/* global window */

import { Component } from 'react';
import { connect } from 'react-redux';

import { getMessage } from 'common/helpers/miscHelper';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import { reservationClick } from 'redux/reservationAvailabilities/actions';
import { createReservationCart } from 'redux/reservationCart/actions';

import Experience from './components/Experience';
import NoResults from './components/NoResults';

class AvailabilityList extends Component {
  componentDidMount() {}

  handleCreateReservation = (
    reservationDate,
    typeId,
    optionId,
    clickProperties
  ) => {
    const { props } = this;
    const { guestCount } = this.props;
    const newReservation = {
      guestCount: convertStringToInteger(guestCount),
      reservationTypeId: typeId,
      reservationTypeOptionId: optionId,
      reservationDate
    };
    const successFunction = () => {
      window.location.href = '/reservation/checkout/checkout';
    };
    const clickEvent = {
      reservationType: clickProperties.reservationType,
      sku: clickProperties.sku,
      price: clickProperties.price,
      noOfGuests: convertStringToInteger(guestCount),
      date: reservationDate
    };
    props.reservationClick(clickEvent);
    props.createReservationCart(newReservation, successFunction);
  };

  render() {
    const { reservationAvailability, settings, reservationDate } = this.props;
    const { guestCount, reservationTime, reservationTypeId } = this.props;
    const { onSearch } = this.props;
    if (!reservationDate) {
      return null;
    }
    if (reservationAvailability.isFetching) {
      return <div className="c7-experiences">Loading...</div>;
    }
    if (!reservationAvailability.query) {
      return null;
    }
    if (reservationAvailability.query.length === 0) {
      return (
        <NoResults
          settings={settings}
          reservationDate={reservationDate}
          reservationTime={reservationTime}
        />
      );
    }
    return (
      <div className="c7-experiences">
        {reservationAvailability.query.map((experienceId) => {
          const experience = reservationAvailability.data[experienceId];
          return (
            <Experience
              onSearch={onSearch}
              experience={experience}
              key={experience.id}
              settings={settings}
              reservationDate={reservationDate}
              guestCount={guestCount}
              reservationTime={reservationTime}
              reservationTypeId={reservationTypeId}
              onCreateReservation={this.handleCreateReservation}
            />
          );
        })}

        <div
          className="c7-experiences__footer"
          dangerouslySetInnerHTML={{
            __html: getMessage('Reservation Help', settings)
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.setting,
  reservationAvailability: state.reservationAvailability
});

export default connect(mapStateToProps, {
  createReservationCart,
  reservationClick
})(AvailabilityList);
